import { cloneDeep } from 'lodash';

export const getStateSetter = (dotPath) => (state, newData) => {
  let newState = cloneDeep(state);
  // eslint-disable-next-line
  let stateNode = dotPath.split('.').reduce((o, i) => o[i], newState); // move down the tree until you hit the right node
  Object.assign(stateNode, newData); // overwrite state with newData, keeping anything unchanged intact
  return newState;
};
